import { useState } from "react";
import { Download, ZoomIn, X } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogClose,
} from "@/components/ui/dialog";
import * as DialogPrimitive from "@radix-ui/react-dialog";

interface ChatImageProps {
  src: string;
  alt?: string;
}

export function ChatImage({ src, alt }: ChatImageProps) {
  const [open, setOpen] = useState(false);

  const handleDownload = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      const response = await fetch(src);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = alt || "imagem-gerada.png";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch {
      window.open(src, "_blank");
    }
  };

  return (
    <>
      <div className="relative group my-2 inline-block max-w-md">
        <img
          src={src}
          alt={alt || "Imagem gerada"}
          className="rounded-lg border border-color cursor-pointer transition-opacity hover:opacity-90 max-w-full"
          onClick={() => setOpen(true)}
          loading="lazy"
        />
        <div className="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            onClick={() => setOpen(true)}
            className="p-1.5 rounded-md bg-background/80 backdrop-blur-sm border border-color hover:bg-hover transition-colors"
            title="Ampliar"
          >
            <ZoomIn className="w-4 h-4 text-primary" />
          </button>
          <button
            onClick={handleDownload}
            className="p-1.5 rounded-md bg-background/80 backdrop-blur-sm border border-color hover:bg-hover transition-colors"
            title="Baixar"
          >
            <Download className="w-4 h-4 text-primary" />
          </button>
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogPortal>
          <DialogOverlay className="bg-black/90" />
          <DialogPrimitive.Content
            className="fixed inset-0 z-50 flex items-center justify-center p-4"
            onClick={() => setOpen(false)}
          >
            <div
              className="relative max-w-[90vw] max-h-[90vh]"
              onClick={(e) => e.stopPropagation()}
            >
              <img
                src={src}
                alt={alt || "Imagem gerada"}
                className="max-w-full max-h-[85vh] rounded-lg object-contain"
              />
              <div className="absolute top-3 right-3 flex gap-2">
                <button
                  onClick={handleDownload}
                  className="p-2 rounded-full bg-background/80 backdrop-blur-sm border border-color hover:bg-hover transition-colors"
                  title="Baixar imagem"
                >
                  <Download className="w-5 h-5 text-primary" />
                </button>
                <button
                  onClick={() => setOpen(false)}
                  className="p-2 rounded-full bg-background/80 backdrop-blur-sm border border-color hover:bg-hover transition-colors"
                  title="Fechar"
                >
                  <X className="w-5 h-5 text-primary" />
                </button>
              </div>
            </div>
          </DialogPrimitive.Content>
        </DialogPortal>
      </Dialog>
    </>
  );
}
